import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { initiateOAuthLogin } from '../auth/directOAuthHandler';

const LoginPage: React.FC = () => {
  const handleLogin = () => {

    initiateOAuthLogin();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#ffffff'
      }}
    >
      <Box
        sx={{
          border: '1px solid #ddd',
          borderRadius: 2,
          padding: 5,
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          textAlign: 'center',
          minWidth: 400,
          backgroundColor: '#fff'
        }}
      >
        {/* Nike Logo */}
        <Box sx={{ mb: 3 }}>
          <img 
            src="/logo.png" 
            alt="Nike" 
            style={{ height: '60px', width: 'auto' }}
          />
        </Box>

        {/* Title */}
        <Typography 
          variant="h4" 
          sx={{ 
            mb: 4,
            fontWeight: 700,
            color: '#000',
            fontSize: '28px',
            fontFamily: "'Impact', 'Arial Black', sans-serif",
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}
        >
          CONNECTED PRODUCTS PLATFORM
        </Typography>
        
        {/* Login Button */}
        <Button 
          variant="contained" 
          onClick={handleLogin}
          sx={{ 
            width: '60%',
            py: 1.2,
            fontSize: '16px',
            textTransform: 'none',
            backgroundColor: '#2196F3',
            fontWeight: 600,
            fontFamily: "'Roboto', 'Helvetica Neue', Arial, sans-serif",
            '&:hover': {
              backgroundColor: '#1976D2'
            }
          }}
        >
          Login
        </Button>
      </Box>
    </Box>
  );
};

export default LoginPage;
